import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Card, Image, Modal, notification, Upload } from "antd";
import { api, baseURL } from "helpers/api";
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";

const Gallery = ({ data }) => {
  const { id: issue_id } = useParams();
  const [{ access_token }] = useCookies(["access_token"]);
  const [delete_issue_image_id, setDeleteIssueImageId] = useState(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const [fileList, setFileList] = useState([
    ...data.map(({ id: uid, image_url, image_thumb_url }) => ({
      uid,
      name: "image.png",
      status: "done",
      url: image_thumb_url,
      preview: image_url,
    })),
  ]);

  const handlePreview = async (file) => {
    setPreviewImage(file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ file, fileList: newFileList }) => {
    if (file.status === "done" && file.response?.data) {
      const { id: uid, image_thumb_url, image_url } = file.response.data;
      const updatedFileList = newFileList.map((item, index) =>
        index === newFileList.length - 1
          ? {
              ...item,
              uid,
              url: image_thumb_url,
              preview: image_url,
            }
          : item
      );

      setFileList(updatedFileList);
    } else {
      setFileList(newFileList);
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/issue_images/${delete_issue_image_id}`);
      notification.success({
        message: "Zdjęcie zostało usunięte",
      });
      setFileList(fileList.filter(({ uid }) => uid !== delete_issue_image_id));
      setDeleteIssueImageId(null);
    } catch (error) {
      notification.error({
        message: "Nie udało się usunąć zdjęcia",
      });
    }
  };

  return (
    <Card
      title={`Zdjęcia (${fileList?.length || 0}/8)`}
      style={{ marginBottom: 24 }}
    >
      {delete_issue_image_id && (
        <Modal
          title="Potwierdzenie"
          open={true}
          onOk={handleDelete}
          onCancel={() => setDeleteIssueImageId(null)}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          Czy na pewno chcesz usunąć zdjęcie?
        </Modal>
      )}
      <Upload
        accept="image/*"
        action={`${baseURL}/issue_images`}
        headers={{
          Authorization: `Bearer ${access_token}`,
        }}
        name="image"
        data={{ issue_id }}
        listType="picture"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={async ({ uid }) => {
          if (typeof uid === "number") {
            setDeleteIssueImageId(uid);
            return false;
          }
        }}
      >
        {fileList.length < 8 && (
          <Button type="primary" icon={<UploadOutlined />}>
            Dodaj zdjęcie
          </Button>
        )}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </Card>
  );
};
export default Gallery;
